import { showcaseIndexUrl, showcaseLayoutUrl } from './config'
import type { ShowcaseIndex, ShowcaseLayout } from './types'

export async function fetchShowcaseIndex(): Promise<ShowcaseIndex> {
  const res = await fetch(showcaseIndexUrl())
  if (!res.ok) {
    throw new Error(
      res.status === 404
        ? 'Showcase index not found. Run compile_showcase.py on the showcase container.'
        : 'Could not load showcase index.',
    )
  }
  return res.json()
}

export async function fetchShowcaseLayout(slug: string): Promise<ShowcaseLayout> {
  const res = await fetch(showcaseLayoutUrl(slug))
  if (!res.ok) {
    throw new Error(
      res.status === 404
        ? `No showcase page for "${slug}".`
        : 'Could not load showcase layout.',
    )
  }
  return res.json()
}
